module.exports = __webpack_public_path__ + "static/img/4_1_3.e2f84a9a.png";